import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../utils/utils";
import ImageWithFallback from "./UI/ImageWithFallback";
import { DiscountBadgePlacement } from "./UI/DiscountBadge";

const SampleCard = ({ image, price, id, name, discountPercent }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
      navigate(`/echantillonDetails/${id}`);
    }, 100);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      handleClick();
    }
  };

  const imageSrc = Array.isArray(image) ? image[0] : image;
  const hasDiscount = typeof discountPercent === "number" && discountPercent > 0;

  return (
    <div
      className={`relative flex-shrink-0 w-28 bg-white rounded-lg shadow-sm overflow-hidden mb-1 cursor-pointer transition-transform ${
        isAnimating ? "transform scale-95" : ""
      }`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={`Voir les détails de l'échantillon ${name} à ${formatPrice(price)}`}
    >
      <div className="relative w-full aspect-square bg-gray-50 overflow-hidden">
        {hasDiscount && <DiscountBadgePlacement percent={discountPercent} />}
        <ImageWithFallback
          src={imageSrc}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="p-1.5 text-start">
        <p className="text-xs font-bold text-gray-900 leading-tight">
          {formatPrice(price)}
        </p>
      </div>
    </div>
  );
};

export default SampleCard;
